import React from 'react';

export const SplashScreen: React.FC = () => {
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: '#0B0F19', padding: '24px', height: '100%' }}>
      <div style={{ fontSize: '32px', fontWeight: '900', letterSpacing: '4px', color: '#fff', textAlign: 'center' }}>
        NEON GRID
      </div>
      <div style={{ fontSize: '12px', letterSpacing: '2px', color: '#8B5CF6', marginTop: '8px', fontWeight: '700', textTransform: 'uppercase' }}>
        GAMES PLATFORM
      </div>
      <div style={{ marginTop: '24px' }}>
        <div style={{ width: '32px', height: '32px', border: '3px solid rgba(139, 92, 246, 0.2)', borderTop: '3px solid #8B5CF6', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
};
